export default "__VITE_ASSET__C5KLWzE2__"